.ux-iws-search-no-results {
    display: block;

    &__icon {
        display: block;
        width: 80px;
        margin: 0 auto 20px;
        font-size: 80px;
        color: #e2e2e2;
    }

    &__popular-searches {
        display: block;
        margin: 20px;
        text-align: center;

        li {
            display: inline-block;
            margin: 0 15px 20px;
        }
    }
}
